
<template>
  <div id="order-payment-result" v-loading="dataLoading">
    <el-dialog v-dialogDragOnly :close-on-click-modal="false" custom-class="lg-dialog order-payment-result" append-to-body :visible="visible" :before-close="hideAdd" :title="$t(title)">
      <!-- 支付结果图标 -->
      <div class="lay-result" :class="resultStyle.layClass">
        <i class="icon" :class="resultStyle.iconClass"></i>
        <span class="text">{{ resultStyle.text }}</span>
      </div>
      <!-- 支付流水信息 -->
      <div class="lay-payment" v-if="isSuccess">
        <h4 class="title">{{$t('portal.zhi-fu-xin-xi')}}</h4>
        <base-info :option="paymentOption" :data="payMessage"></base-info>
      </div>
      <!-- 底部按钮 -->
      <div class="lay-footer" v-if="showFooter">
        <template v-if="isSuccess">
          <el-button size="medium" @click="hide">{{$t(colseText)}}</el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { paymentResultField, promptResultField } from '~/common/components/dialog/payDialog/config.js';
import BaseInfo from '~/common/components/detail/BaseInfo.vue';
export default {
  name: 'OrderPaymentResult',
  components: {
    BaseInfo
  },
  props: {
    postOrderId: {
      type: Array,
      default: []
    },
    colseText: {
      type: String,
      default: 'portal.guan-bi'
    },
    title: {
      type: String,
      default: 'portal.zhi-fu-shou-yin-tai'
    },
    visible: {
      type: Boolean,
      default: false
    },
    payMessage: {
      type: Object,
      default: () => ({})
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dataLoading: false,
      paymentOption: {
        field: this.title === this.$t('portal.jiao-ge-zhi-fu') ? promptResultField : paymentResultField,
        showAll: true,
        showBanner: false,
        showLogo: false,
        maxLabelWidth: 100
      },
      paymentInfo: {}
    };
  },
  computed: {
    isSuccess() {
      return this.payMessage.is_success;
    },
    // 成功或者失败的样式和文案在这里处理
    resultStyle() {
      const isSuccess = this.isSuccess;
      return {
        text: isSuccess ? this.$t('portal.zhi-fu-cheng-gong') : this.$t('portal.zhi-fu-shi-bai'),
        layClass: isSuccess ? 'success' : 'error',
        iconClass: isSuccess ? 'el-icon-success' : 'el-icon-error'
      };
    }
  },
  watch: {},
  created() {},
  methods: {
    hide() {
      // if (this.colseText === '查看订单') {
      //   if(this.payMessage.order_type === 'ret'){
      //     window.open(`/store/order/sale_return?id=${this.postOrderId[0]}`, '_black');
      //     return;
      //   }
      //   if(this.payMessage.type === 'platform'){
      //     window.open(`/store/order/purchase_bill?id=${this.postOrderId[0]}`, '_black');
      //     return;
      //   }
      //   if(this.payMessage.type === 'offline'&&this.payMessage.match_type === 'S'){
      //     window.open(`/store/order/sale_bill?id=${this.postOrderId[0]}`, '_black');
      //     return;
      //   }
      //   if(this.payMessage.type === 'offline'&&this.payMessage.match_type === 'P'){
      //     window.open(`/store/order/purchase_bill?id=${this.postOrderId[0]}`, '_black');
      //     return;
      //   }
      // }
      let m = this.$store.state.pay.payRefresh
      this.$store.commit('pay/set_payRefresh', ++m)
      this.$emit('hide',{isSuccess:this.isSuccess})
    },
    hideAdd() {
      let m = this.$store.state.pay.payRefresh;
      this.$store.commit('pay/set_payRefresh', ++m);
      this.$emit('hide',{isSuccess:this.isSuccess})
    }
  }
};
</script>

<style lang="less">
.order-payment-result {
  overflow: auto;
  .el-loading-mask {
    border: none;
  }
  .lay-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 46px;
    padding: 0 10px;
    border-bottom: 1px solid #efefef;
    .title {
      font-size: 16px;
    }
  }
  .lay-result,
  .lay-payment {
    padding: 12px 20px;
    border-bottom: 1px solid #efefef;
    .title {
      margin-bottom: 10px;
      font-size: 15px;
      line-height: 28px;
      color: #3f3f3f;
    }
  }
  .lay-result {
    display: flex;
    align-items: center;
    justify-content: center;
    &.success {
      height: 130px;
    }
    &.error {
      height: 35vh;
    }
    .icon {
      font-size: 50px;
      margin-right: 10px;
    }
    .el-icon-success {
      color: #20cb1d;
    }
    .el-icon-error {
      color: red;
    }
    .text {
      font-size: 20px;
      font-weight: 700;
    }
  }
  .lay-payment {
    .base-info .el-col .u-label {
      text-decoration: none;
    }
    .custom-style {
      margin-bottom: 10px;
    }
  }
  .lay-footer {
    padding: 25px 0 20px;
    text-align: center;
    .el-button {
      width: 126px;
      margin: 15px;
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
